<template lang="pug">
.the-sidebar
    .the-sidebar__logo
        slot(
            name="logo"
        )

    nav.the-sidebar__menu
        slot(
            name="menu"
        )

    .the-sidebar__profile
        slot
</template>

<script>
export default {
  name: 'TheSidebar',
};
</script>

<style lang="scss" scoped>
.the-sidebar {
    position: sticky;
    top: 30px;
    background: linear-gradient(180deg, #017CD4 0%, #2DA7FF 100%);
    box-shadow: 0px 5px 20px rgba(18, 140, 228, 0.3);
    border-radius: 15px;
    padding: 30px 15px;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: calc(100vh - 60px); // Отступы внешнего блока

    &__logo {
        display: flex;
        justify-content: center;
        margin-top: 13px;
    }
}
</style>
